import React from "react";

import { Col, Container, Row } from "../../../components/Grid/Grid";
import { SVG_ICONS } from "../../../components/__common/Svg/Svg";
import {
  CBType,
  Checkbox,
} from "../../../components/__common/_controls/Checkbox/Checkbox";
import { GpsCountry } from "../../../types/gps-region";

export interface GpsCountryListProps {
  countries: GpsCountry[];
  /** ID to assign to the last item's checkbox (for tab-trap). */
  lastItemId?: string;
  onCountrySelect: (country: GpsCountry) => void;
}

/** Reusable checkbox list of GPS countries. */
export const GpsCountryList: React.FC<GpsCountryListProps> = ({
  countries,
  lastItemId,
  onCountrySelect,
}) => {
  return (
    <Container>
      <Row>
        {countries.map((country, index) => {
          const isLast = index === countries.length - 1;
          return (
            <Col md={6} sm={12} key={country.code}>
              <Checkbox
                id={isLast ? lastItemId : undefined}
                key={country.code}
                title={country.name}
                name="checkbox-withoutSelectBg"
                type={CBType.withoutSelectBg}
                onClick={() => onCountrySelect(country)}
                svgIcon={SVG_ICONS.ARROW_RIGHT}
              />
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};
